export default __webpack_public_path__ + "static/media/two-way.92cbbb48.svg";